import { Link, graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import SocialIcons from '../SocialIcons';
import Logo from '../../assets/images/logo.png';
import Icon from '../Icon';
import ClutchWidget from './ClutchWidget';
import Badge from '../Badge';

export default function Footer({ isRegularFooter }) {
  const data = useStaticQuery(graphql`
    query {
      footer: contentfulSiteWide(
        internalName: { eq: "Site Wide DO NOT DELETE" }
      ) {
        id
        footerMenu {
          ... on ContentfulNavigationDropdown {
            id
            parentNavigationItem {
              name
              slug
            }
            pages {
              ... on ContentfulPages {
                name
                slug
              }
              ... on ContentfulStaticPage {
                name
                slug
              }
            }
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }
          ... on ContentfulPages {
            name
            slug
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }
          ... on ContentfulStaticPage {
            name
            slug
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }
        }
        footerBadges {
          id
          image {
            title
            description
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
          url
        }
        footerText {
          id
          url
          altText
        }
      }
    }
  `);

  if (isRegularFooter)
    return (
      <footer>
        <div className="flex-container">
          <div className="main">
            <Link to="/" className="test-2">
              <img src={Logo} alt="CrossComm" className="logo" />
            </Link>
            <ul>
              {data.footer.footerMenu.map((link) =>
                link.sys.contentType.sys.id === 'navigationDropdown' ? (
                  <li key={link.parentNavigationItem.name}>
                    <div className="dropdown">
                      <Link
                        to={`/${link.parentNavigationItem.slug}/`}
                        activeClassName="active"
                        partiallyActive
                      >
                        {link.parentNavigationItem.name}
                        <Icon
                          icon={['fas', 'caret-down']}
                          size="sm"
                          className="dropdown-icon"
                        />
                      </Link>
                      <div className="dropdown-content">
                        {link.pages.map((sublink) => (
                          <Link
                            key={sublink.name}
                            to={`/${link.parentNavigationItem.slug}/${sublink.slug}`}
                            activeClassName="active"
                          >
                            {sublink.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </li>
                ) : (
                  <li key={link.name}>
                    <Link
                      to={link.slug === 'home' ? '/' : `/${link.slug}/`}
                      activeClassName="active"
                      partiallyActive={link.slug !== 'home'}
                    >
                      {link.name}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
          <div className="aside aside-1">
            <Link to="/" className="logo-container">
              <img src={Logo} alt="CrossComm" className="logo" />
            </Link>
            <ul>
              {data.footer.footerBadges.map((badge) => (
                <li key={badge.id}>
                  <Badge {...badge} />
                </li>
              ))}
            </ul>
            <a
              target="_blank"
              href={data.footer.footerText.url}
              className="footer-text"
              rel="noreferrer"
            >
              {data.footer.footerText.altText}
            </a>
            <h3>
              &copy; 1998-{new Date().getFullYear()} CrossComm, Inc. All Rights
              Reserved
            </h3>
          </div>
          <div className="aside aside-2">
            <SocialIcons />
            <ClutchWidget />
          </div>
        </div>
      </footer>
    );
  return (
    <footer className="footer-condensed">
      <div className="flex-container">
        <div className="main">
          <Link to="/" className="test-2">
            <img src={Logo} alt="CrossComm" className="logo" />
          </Link>
        </div>
        <div className="aside aside-3">
          <div className="logoContainer">
            <Link to="/" className="logo-container">
              <img src={Logo} alt="CrossComm" className="logo" />
            </Link>
            <h3>
              &copy; 1998-{new Date().getFullYear()} CrossComm, Inc. All Rights
              Reserved
            </h3>
          </div>
          <div className="footer-end">
            <div className="footer-icons">
              <ul>
                {data.footer.footerBadges.slice(0, 2).map((badge) => (
                  <li key={badge.id}>
                    <Badge {...badge} />
                  </li>
                ))}
              </ul>
              <SocialIcons />
            </div>
            <a
              target="_blank"
              rel="noreferrer"
              href={data.footer.footerText.url}
              className="condensed-text"
            >
              {data.footer.footerText.altText}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
